const DEFAULT_PIECE_SIZE = 600;
const DEFAULT_JPEG_QUALITY = 0.9;

export function exportGridImages({
  canvas,
  img,
  grid,
  scale,
  offset,
  pieceSize = DEFAULT_PIECE_SIZE,
  quality = DEFAULT_JPEG_QUALITY,
}) {
  if (!canvas || !img || !grid || !scale || !offset) return [];

  const { cols, rows } = grid;
  const cellWidth = canvas.width / cols;
  const cellHeight = canvas.height / rows;
  const outputCanvas = document.createElement("canvas");
  const ctx = outputCanvas.getContext("2d");
  const output = [];

  outputCanvas.width = pieceSize;
  outputCanvas.height = pieceSize;

  ctx.imageSmoothingEnabled = true;
  ctx.imageSmoothingQuality = "high";

  for (let row = 0; row < rows; row += 1) {
    for (let column = 0; column < cols; column += 1) {
      const scaleX = pieceSize / cellWidth;
      const scaleY = pieceSize / cellHeight;

      ctx.save();
      ctx.clearRect(0, 0, pieceSize, pieceSize);
      ctx.fillStyle = "#fff";
      ctx.fillRect(0, 0, pieceSize, pieceSize);

      ctx.drawImage(
        img,
        (offset.x - column * cellWidth) * scaleX,
        (offset.y - row * cellHeight) * scaleY,
        img.width * scale * scaleX,
        img.height * scale * scaleY,
      );

      ctx.restore();
      output.push(outputCanvas.toDataURL("image/jpeg", quality));
    }
  }

  return output;
}
